import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import AFSO_FPS from "./AFSO_FPS";
import progressGif from "../../images/progress.gif";

const DFSO_FPS = () => {
  const [activeMonthYear, setActiveMonthYear] = useState(null);
  const [fpsSummary, setFpsSummary] = useState([]);
  const [error, setError] = useState(null);
  const [afsoLoading, setAfsoLoading] = useState(false);
  const [selectedDistCode, setSelectedDistCode] = useState(null);
  const [selectedDistName, setSelectedDistName] = useState(null);
  const [showAfsoTable, setShowAfsoTable] = useState(false);
  const afsoRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [monthYearRes, fpsSummaryRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_URL_FPS}/api/fps/activeMonthYear`),
          axios.get(`${process.env.REACT_APP_URL_FPS}/api/fps/fpsSummary`)
        ]);
        setActiveMonthYear(monthYearRes.data);
        setFpsSummary(fpsSummaryRes.data);
      } catch (err) {
        console.error(err);
        setError("");
      }
    };
    fetchData();
  }, []);


  const scrollToAfso = () => {
    if (afsoRef.current) {
      afsoRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    if (showAfsoTable) {
      scrollToAfso();
    }
  }, [showAfsoTable]);

  if (error) return <div>{error}</div>;

  const handleDownloadExcel = () => {
    const wsData = [];

    wsData.push(["FPS Details"]);
    wsData.push([
      "Sl.No", "District", "Total", "Device", "", "Dealer UID", "", "Nominee 1 UID", "", "Nominee 2 UID", "", "Weighing", "", "Grain ATM", ""
    ]);
    wsData.push([
      "", "", "", "Mapped", "Not Mapped", "Mapped", "Not Mapped", "Mapped", "Not Mapped", "Mapped", "Not Mapped", "Enabled", "Not Enabled", "Enabled", "Not Enabled"
    ]);

    fpsSummary.forEach((row, index) => {
      wsData.push([
        index + 1,
        row.distNameEn,
        row.totalShops || 0,
        row.mappedShops || 0,
        (row.totalShops || 0) - (row.mappedShops || 0),
        row.dealerMappedShops || 0,
        (row.totalShops || 0) - (row.dealerMappedShops || 0),
        row.nom1MappedShops || 0,
        (row.totalShops || 0) - (row.nom1MappedShops || 0),
        row.nom2MappedShops || 0,
        (row.totalShops || 0) - (row.nom2MappedShops || 0),
        row.weightingEnabled || 0,
        row.weightingNotEnabled || 0,
        row.grainStEnabled || 0,
        row.grainStNotEnabled || 0
      ]);
    });

    wsData.push([
      "Total", "",
      fpsSummary.reduce((sum, r) => sum + (r.totalShops || 0), 0),
      fpsSummary.reduce((sum, r) => sum + (r.mappedShops || 0), 0),
      fpsSummary.reduce((sum, r) => sum + ((r.totalShops || 0) - (r.mappedShops || 0)), 0),
      fpsSummary.reduce((sum, r) => sum + (r.dealerMappedShops || 0), 0),
      fpsSummary.reduce((sum, r) => sum + ((r.totalShops || 0) - (r.dealerMappedShops || 0)), 0),
      fpsSummary.reduce((sum, r) => sum + (r.nom1MappedShops || 0), 0),
      fpsSummary.reduce((sum, r) => sum + ((r.totalShops || 0) - (r.nom1MappedShops || 0)), 0),
      fpsSummary.reduce((sum, r) => sum + (r.nom2MappedShops || 0), 0),
      fpsSummary.reduce((sum, r) => sum + ((r.totalShops || 0) - (r.nom2MappedShops || 0)), 0),
      fpsSummary.reduce((sum, r) => sum + (r.weightingEnabled || 0), 0),
      fpsSummary.reduce((sum, r) => sum + (r.weightingNotEnabled || 0), 0),
      fpsSummary.reduce((sum, r) => sum + (r.grainStEnabled || 0), 0),
      fpsSummary.reduce((sum, r) => sum + (r.grainStNotEnabled || 0), 0)
    ]);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 14 } }];
    XLSX.utils.book_append_sheet(wb, ws, "FPS_Summary");
    XLSX.writeFile(wb, `FPS_Summary_${activeMonthYear?.month}_${activeMonthYear?.year}.xlsx`);
  };

  const handleDistrictClick = (distCode, distName) => {
    setSelectedDistCode(distCode);
    setSelectedDistName(distName);
    setAfsoLoading(true);
    setShowAfsoTable(false);

    setTimeout(() => {
      setAfsoLoading(false);
      setShowAfsoTable(true);
    }, 100);
  };

  return (
    <div style={{ paddingTop: "20px" }}>
      <table id="mlstab2" align="center" width="70%" border="1" cellPadding="5">
        <thead>
          <tr className="tableheader"><th colSpan="15">FPS Details</th></tr>
          <tr className="tableheader">
            <th rowSpan="2">Sl.No</th>
            <th rowSpan="2">District</th>
            <th rowSpan="2">Total</th>
            <th colSpan="2">Device</th>
            <th colSpan="2">Dealer UID</th>
            <th colSpan="2">Nominee 1 UID</th>
            <th colSpan="2">Nominee 2 UID</th>
            <th colSpan="2">Weighing</th>
            <th colSpan="2">Grain ATM</th>
          </tr>
          <tr className="tableheader">
            <th>Mapped</th><th>Not<br />Mapped</th>
            <th>Mapped</th><th>Not<br />Mapped</th>
            <th>Mapped</th><th>Not<br />Mapped</th>
            <th>Mapped</th><th>Not<br />Mapped</th>
            <th>Enabled</th><th>Not<br />Enabled</th>
            <th>Enabled</th><th>Not<br />Enabled</th>
          </tr>
        </thead>
        <tbody>
          {fpsSummary.map((row, index) => {
            const deviceMapped = row.mappedShops || 0;
            const deviceNotMapped = (row.totalShops || 0) - deviceMapped;
            const dealerMapped = row.dealerMappedShops || 0;
            const dealerNotMapped = (row.totalShops || 0) - dealerMapped;
            const nom1Mapped = row.nom1MappedShops || 0;
            const nom1NotMapped = (row.totalShops || 0) - nom1Mapped;
            const nom2Mapped = row.nom2MappedShops || 0;
            const nom2NotMapped = (row.totalShops || 0) - nom2Mapped;

            return (
              <tr key={index}>
                <td align="center">{index + 1}</td>
                <td
                  onClick={() => handleDistrictClick(row.distCode, row.distNameEn)}
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "inherit")}
                >
                  {row.distNameEn}
                </td>
                <td align="right">{row.totalShops}</td>
                <td align="right">{deviceMapped}</td>
                <td align="right">{deviceNotMapped}</td>
                <td align="right">{dealerMapped}</td>
                <td align="right">{dealerNotMapped}</td>
                <td align="right">{nom1Mapped}</td>
                <td align="right">{nom1NotMapped}</td>
                <td align="right">{nom2Mapped}</td>
                <td align="right">{nom2NotMapped}</td>
                <td align="right">{row.weightingEnabled}</td>
                <td align="right">{row.weightingNotEnabled}</td>
                <td align="right">{row.grainStEnabled}</td>
                <td align="right">{row.grainStNotEnabled}</td>
              </tr>
            );
          })}

          <tr className="tableheader">
            <td colSpan="2" align="center">Total</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.totalShops || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.mappedShops || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + ((row.totalShops || 0) - (row.mappedShops || 0)), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.dealerMappedShops || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + ((row.totalShops || 0) - (row.dealerMappedShops || 0)), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.nom1MappedShops || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + ((row.totalShops || 0) - (row.nom1MappedShops || 0)), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.nom2MappedShops || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + ((row.totalShops || 0) - (row.nom2MappedShops || 0)), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.weightingEnabled || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.weightingNotEnabled || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.grainStEnabled || 0), 0)}</td>
            <td align="right">{fpsSummary.reduce((sum, row) => sum + (row.grainStNotEnabled || 0), 0)}</td>
          </tr>
        </tbody>
      </table>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={() => window.history.back()}
          style={{
            padding: "6px 15px",
            borderRadius: "10px",
            border: "none",
            backgroundColor: "black",
            color: "white",
            cursor: "pointer", marginRight: "15px"
          }}
        >
          Back
        </button>
        <button
          onClick={handleDownloadExcel}
          style={{ padding: "6px 15px", fontSize: "14px", backgroundColor: "black", color: "white", border: "none", borderRadius: "20px", cursor: "pointer" }}
        >
          Data To Excel
        </button>
      </div>

      {afsoLoading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <img src={progressGif} alt="Loading..." width="250" height="15" />
        </div>
      )}

      {showAfsoTable && selectedDistCode && (
        <div ref={afsoRef}>
          <AFSO_FPS
            distCode={selectedDistCode}
            distName={selectedDistName}
            setAfsoLoading={setAfsoLoading}
          />
        </div>
      )}

    </div>
  );
};

export default DFSO_FPS;
